export function getUserFirstName(username?: string): string {
    return username?.trim().split(/\s+/)[1] ?? username ?? ''
}
